import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType, GridColumnWithoutSort } from "@/components/child/grid/gridColumn";
import "@/components/parent/crud/crud.scss";
import { Component } from "@/decorators";
import TipoNotaFiscal from "@/models/enum/tipoNotaFiscal";
import NotaFiscalSaidaModel from "@/models/notaFiscalSaidaModel";
import PaginationModel from "@/models/paginationModel";
import NotaFiscalServicoEmissaoService from "@/services/notaFiscal/notaFiscalServicoEmissaoService";
import NotaFiscalSaidaService from "@/services/notaFiscalSaidaService";
import { addDays, convertToDateInputString } from "@/utils/common/date";

import ListComponentBase from "../../crud/listComponentBase";

const service = new NotaFiscalSaidaService();
const serviceEmissao = new NotaFiscalServicoEmissaoService();

@Component({
    components: {
        gridComponent,
        dateTimePickerComponent,
        checkboxComponent,
        comboComponent,
    },
})
export default class CancelamentoNotasFiscaisSaidaDuplicadasList extends ListComponentBase<NotaFiscalSaidaModel> {
    private notasSelecionadas: NotaFiscalSaidaModel[] = [];

    private emissaoDe: Date = addDays(-30, new Date());
    private emissaoAte: Date = new Date();
    private apenasNaoCanceladas: boolean = true;
    private tipoNota: number = -1;

    private tipoNotaOptions: Array<Object> = [
        {
            text: this.$t("__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.tipoNotaAmbas"),
            value: -1,
        },
        {
            text: this.$t(
                "__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.tipoNotaServico",
            ),
            value: TipoNotaFiscal.Servico,
        },
        {
            text: this.$t("__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.tipoNotaNFe"),
            value: TipoNotaFiscal.DANFe,
        },
    ];

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumnWithoutSort(
                "numero",
                this.$t("__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.numero"),
                GridColumnType.String,
            ),
            new GridColumnWithoutSort(
                "clienteNome",
                this.$t("__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.clienteNome"),
                GridColumnType.String,
            ),
            new GridColumnWithoutSort(
                "codigoVenda",
                this.$t("__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.codigoVenda"),
                GridColumnType.String,
            ),
            new GridColumnWithoutSort(
                "tipoDescricao",
                this.$t("__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.tipo"),
                GridColumnType.String,
            ),
            new GridColumnWithoutSort(
                "dataVenda",
                this.$t("__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.dataVenda"),
                GridColumnType.DateTime,
            ),
            new GridColumnWithoutSort(
                "dataEmissao",
                this.$t("__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.dataEmissao"),
                GridColumnType.DateTime,
            ),
            new GridColumnWithoutSort(
                "valorTotal",
                this.$t("__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.valor"),
                GridColumnType.Money,
            ),
        ];
    }

    public async loadMethod() {
        return await service
            .listDuplicadas(
                this.pageIndex,
                this.pageSize,
                this.gridFilterKey,
                convertToDateInputString(this.emissaoDe),
                convertToDateInputString(this.emissaoAte),
                this.apenasNaoCanceladas,
                this.tipoNota,
            )
            .withLoading()
            .resolveWithJSON<PaginationModel<NotaFiscalSaidaModel>>();
    }

    private onSelectedValuesChanged(values: Array<NotaFiscalSaidaModel>) {
        this.notasSelecionadas = values;
    }

    private async cancelarEmLote() {
        const confirmado = await this.$showQuestion(
            this.$t("__.ts.atencao"),
            this.$t(
                "__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.confirmacaoCancelamentoEmLote",
            ),
        );
        if (!confirmado) return;

        try {
            const retorno = await serviceEmissao
                .cancelarEmLoteDuplicadas(this.notasSelecionadas.map(n => n.searchKey))
                .withLoading()
                .resolveWithText();

            this.$showInfo(this.$t("__.ts.alt"), retorno);
        } catch (error) {
            this.$showError(this.$t("__.ts.erro"), "Falha ao tentar cancelar as notas.");
        }

        await this.load();
    }
}
